export class FeatureValueObject {
  constructor(
    public readonly geometry: { type: string; coordinates: any },
    public readonly properties: Record<string, unknown>,
  ) {}
}

export class GeoJsonValueObject {
  constructor(
    public readonly type: string,
    public readonly features: FeatureValueObject[],
  ) {}
}
